<template>
    <div v-if="color === 'blue'" class="card card-pdv card-work-schedule-statement">
        <PageHeader :title="title" :show-slot="displayMoreButton && !busy">
            <a v-if="displayMoreButton" href="javascript: void(0);" @click="handleModal">
                <i class="fe-more-horizontal icon-blue" />
            </a>
        </PageHeader>
        <div class="card-body">
            <b-row v-if="busy">
                <b-col md="12">
                    <b-skeleton type="button" width="100%" height="60px"></b-skeleton>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col md="12" class="text-center">
                    <label class="main-text-work-schedule-statement-blue">{{ valueFormatted }}</label>
                    <label v-if="showTotalRecords" class="complement-text">{{ getI18n('PAGINATION', 'of') }} {{ padLeft(totalRecords) }}</label>
                </b-col>
            </b-row>
        </div>
        <div class="footer-work-schedule-statement">
            <p class="text-footer">{{ footerPosActiveText }}</p>
            <p class="text-footer">{{ footerPosScheduleText }}</p>
        </div>
    </div>

    <div v-else class="card card-pdv card-work-schedule-statement">
        <PageHeader :title="title" :show-slot="displayMoreButton && !busy">
            <a v-if="displayMoreButton" href="javascript: void(0);" @click="handleModal">
                <i class="fe-more-horizontal icon-blue" />
            </a>
        </PageHeader>
        <div class="card-body">
            <b-row v-if="busy">
                <b-col md="12">
                    <b-skeleton type="button" width="100%" height="60px"></b-skeleton>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col md="12" class="text-center">
                    <label class="main-text-work-schedule-statement-black">{{ valueFormatted }}</label>
                    <label v-if="showTotalRecords" class="complement-text">{{ getI18n('PAGINATION', 'of') }} {{ padLeft(totalRecords) }}</label>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import PageHeader from '@/src/components/PageHeader.vue'
    import vuetableFormatters from '@src/mixins/vuetableFormatters'

    export default {
        components: {
            PageHeader,
        },
        mixins: [
            vuetableFormatters,
        ],
        props: {
            color: {
                type: String,
                required: false,
                default: 'blue',
            },
            title: {
                type: String,
                required: true,
            },
            busy: {
                type: Boolean,
                required: false,
            },
            displayMoreButton: {
                type: Boolean,
                required: false,
            },
            type: {
                type: String,
                required: false,
                default: '',
            },
            value: {
                type: Number,
                required: false,
                default: 0,
            },
            showTotalRecords: {
                type: Boolean,
                required: false,
            },
            totalRecords: {
                type: Number,
                required: false,
                default: 0,
            },
            textColor: {
                type: String,
                required: false,
                default: '#2E7FEB',
            },
            textPosActive: {
                type: String,
                required: false,
                default: '',
            },
            textPosSchedule: {
                type: String,
                required: false,
                default: '',
            },
            posActiveCount: {
                type: Number,
                required: false,
                default: 0,
            },
            posScheduleCount: {
                type: Number,
                required: false,
                default: 0,
            },
        },
        data () {
            return {}
        },
        computed: {
            footerPosActiveText() {
                return `${this.textPosActive || ''}${this.displayNumber(this.posActiveCount)}`
            },
            footerPosScheduleText() {
                return `${this.textPosSchedule || ''}${this.displayNumber(this.posScheduleCount)}`
            },
            valueFormatted() {
                if (this.type === 'currency') {
                    return this.getI18nCurrency(this.value)
                }
                else if (this.type === 'percentage') {
                    return `${Number.isFinite(this.value) ? Math.round(this.value) : 0}%`
                }
                return this.padLeft(this.value)
            },
        },
        methods: {
            displayNumber(val) {
                const n = Number(val)
                return Number.isFinite(n) ? n : 0
            },
            handleModal() {
                if (this.busy) {
                    return
                }
                this.$emit('onClick')
            },
        },
    }
</script>

<style>
    .card-work-schedule-statement {
        text-align: center;
    }
    .main-text-work-schedule-statement-blue {
        font-family: 'Exo2-Bold', sans-serif;
        font-size: 40px;
        font-style: normal;
        font-weight: 800;
        line-height: 120%;
        color: #2E7FEB;
    }
    .main-text-work-schedule-statement-black {
        font-family: 'Exo2-Bold', sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 800;
        line-height: 120%;
        color: #333;
    }
    .complement-text {
        margin-left: 5px;
        font-family: 'Exo2', sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: normal;
        line-height: 120%;
        color: #404249;
        text-align: center;
        letter-spacing: 0.02em;
    }
    .card-work-schedule-statement h4 {
        font-weight: 600 !important;
    }
    .footer-work-schedule-statement {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 20px;
    }
    .text-footer {
        margin-bottom: 0 !important;
        font-family: "Exo2-Regular", sans-serif;
        font-size: 12px;
        font-weight: 500;
        color: #404249;
    }
</style>
